/* eslint-disable no-unused-vars */
import React from "react";
import Container from "./Container";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/24/solid";
import { ScrollRevealStagger, ScrollRevealStaggerItem } from "./ScrollReveal";

const Faq = () => {
  return (
    <Container className="py-10 lg:py-14">
      <div className="mx-auto w-full max-w-2xl">
        <ScrollRevealStagger className="space-y-4">
          {faqdata.map((item) => (
            <ScrollRevealStaggerItem key={item.question} className="mb-4">
            <Disclosure>
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full items-center justify-between rounded-xl border border-slate-200 bg-white px-5 py-4 text-left text-slate-900 transition hover:border-slate-300 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/20">
                    <span className="font-medium">{item.question}</span>
                    <ChevronUpIcon
                      className={`h-5 w-5 flex-shrink-0 text-emerald-600 transition-transform ${
                        open ? "rotate-180" : ""
                      }`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="rounded-b-xl border border-t-0 border-slate-200 bg-slate-50/50 px-5 py-4 text-slate-600">
                    {item.answer}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
            </ScrollRevealStaggerItem>
          ))}
        </ScrollRevealStagger>
      </div>
    </Container>
  );
};

const faqdata = [
  {
    question: "Is LeadZLab free to use?",
    answer:
      "LeadZLab is currently in beta. We’ll launch pricing plans later—until then it’s free to use.",
  },
  {
    question: "I have suggestions or feature requests",
    answer:
      "We’d love to hear from you. Email support@leadzlab.co and we’ll get back soon.",
  },
  {
    question: "How do I get started?",
    answer:
      "Sign up, add your keywords, subreddits, and LinkedIn—we’ll surface matching threads and posts. Need help? Email support@leadzlab.co.",
  },
  // {
  //   question: "Do you offer technical support? ",
  //   answer:
  //     "No, we don't offer technical support for free downloads. Please purchase a support plan to get 6 months of support.",
  // },
];

export default Faq;
